import { Callout } from '@/components/Callout/Callout'

export interface FinalizedSourceCalloutProps {
  generation: number | null
}

export const FinalizedSourceCallout = ({ generation }: FinalizedSourceCalloutProps) => (
  <Callout.Root>
    <Callout.Header>
      <Callout.Title>
        {generation != null
          ? `Generation ${generation} is the finalized record for this meeting`
          : 'This meeting has a finalized record'}
      </Callout.Title>
    </Callout.Header>
    <Callout.Description>
      {generation != null
        ? `Any edits you make save as a working copy. Finalize again to publish them as generation ${generation + 1}.`
        : 'Any edits you make save as a working copy. Finalize again to publish them as the next generation.'}
    </Callout.Description>
  </Callout.Root>
)
